export const BOARD_HIERARCHIES_LOAD = 'BOARD_HIERARCHIES_LOAD';
export const BOARD_HIERARCHIES_LOAD_ELEMENTS = 'BOARD_HIERARCHIES_LOAD_ELEMENTS';
export const BOARD_HIERARCHIES_REMOVE = 'BOARD_HIERARCHIES_REMOVE';
